function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DefaultDashboard;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _components = require("../../../components");
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _utils = require("../../../utils");
var _DefaultDashboardController = require("./DefaultDashboardController");
var _types = require("../types");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["item", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var controller = new _DefaultDashboardController.DefaultDashboardController();
function DefaultDashboard() {
  var _person$whatsNexts, _person$whatsNexts2;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepsPageLinkUrl = _useContext.stepsPageLinkUrl;
  var _controller$useContro = controller.useController(),
    person = _controller$useContro.person,
    steps = _controller$useContro.steps,
    isLoading = _controller$useContro.isLoading;
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.View, {
      testID: "Dashboard-".concat(_types.dashboardType["default"])
    }), !!(person != null && (_person$whatsNexts = person.whatsNexts) != null && _person$whatsNexts[0]) && (0, _jsxRuntime.jsxs)(_components.View, {
      style: styles.container,
      children: [(0, _jsxRuntime.jsx)(_components.Heading, {
        level: 2,
        style: styles.heading,
        children: t('defaultDashboard:whatNext.title')
      }), (0, _jsxRuntime.jsx)(_components.WhatNext, {
        data: person == null ? void 0 : (_person$whatsNexts2 = person.whatsNexts) == null ? void 0 : _person$whatsNexts2[0]
      })]
    }), !!steps && steps.length > 0 && (0, _jsxRuntime.jsxs)(_components.View, {
      style: styles.section,
      testID: "RecommendedSteps",
      children: [(0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
        value: {
          source: 'Default Dashboard Recommended Steps'
        },
        children: (0, _jsxRuntime.jsx)(_components.StepCarousel, {
          totalItems: steps == null ? void 0 : steps.length,
          items: steps,
          ItemTemplate: function ItemTemplate(_ref) {
            var item = _ref.item,
              style = _ref.style,
              args = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
            return (0, _jsxRuntime.jsx)(_components.StepCardTemplate, Object.assign({
              action: item,
              style: style
            }, args));
          },
          title: t('defaultDashboard:steps.title'),
          testID: "RecommendedStepsCarousel"
        })
      }), stepsPageLinkUrl && (0, _jsxRuntime.jsx)(_components.Button, {
        type: _components.ButtonType.brand,
        href: stepsPageLinkUrl,
        label: t('defaultDashboard:steps.cta'),
        containerStyle: styles.cta
      })]
    }), (0, _jsxRuntime.jsx)(_components.View, {
      style: styles.container,
      children: (0, _jsxRuntime.jsx)(_components.FootprintValue, {
        kgCo2eEmissions: person == null ? void 0 : person.kgCo2eEmissions,
        style: styles.section
      })
    })]
  });
}